import { IconProps } from '@/types/icon';

export function IconeAdicionar({ size, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="adicionar"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}
      {...props}
    >
      <path
        d="M12.6667 8.66671H8.66671V12.6667H7.33337V8.66671H3.33337V7.33337H7.33337V3.33337H8.66671V7.33337H12.6667V8.66671Z"
        fill="currentColor"
      />
    </svg>
  );
}
